export type ProductDeploymentProfile = 'legacy-app' | 'www-candidate';

const SAT_ROUTE_ROOTS = new Set([
  'today',
  'practice',
  'insights',
  'cheatsheet',
  'onboarding',
  'goal-setup',
  'map-reveal',
  'celebration',
  'coach',
  'profile',
  'settings',
]);

const CANDIDATE_SHELL_PATHS: Readonly<Record<string, string>> = {
  '/login': '/auth/login',
  '/access-pending': '/account/access-pending',
  '/choose-role': '/account/choose-role',
  '/offline': '/status/offline',
  '/unavailable': '/status/unavailable',
  '/learn/library': '/learn',
};

function pathEnd(value: string): number {
  const query = value.indexOf('?');
  const hash = value.indexOf('#');
  if (query === -1) return hash === -1 ? value.length : hash;
  return hash === -1 ? query : Math.min(query, hash);
}

function isLegacySatPath(pathname: string): boolean {
  if (!pathname.startsWith('/')) return false;
  const firstSegment = pathname.slice(1).split('/', 1)[0];
  return SAT_ROUTE_ROOTS.has(firstSegment);
}

export function canonicalProductPath(
  destination: string,
  profile: ProductDeploymentProfile = __PINPOINT_DEPLOYMENT_PROFILE__,
): string {
  if (profile !== 'www-candidate') return destination;
  const end = pathEnd(destination);
  const pathname = destination.slice(0, end);
  const candidateShellPath = CANDIDATE_SHELL_PATHS[pathname];
  if (candidateShellPath) return `${candidateShellPath}${destination.slice(end)}`;
  if (!isLegacySatPath(pathname)) return destination;
  if (pathname === '/practice') return `/sat${destination.slice(end)}`;
  return `/sat${destination}`;
}

export function routePolicyPath(
  pathname: string,
  profile: ProductDeploymentProfile = __PINPOINT_DEPLOYMENT_PROFILE__,
): string {
  if (profile !== 'www-candidate') return pathname;
  if (pathname === '/sat' || pathname === '/sat/') return '/practice';
  return pathname.startsWith('/sat/') ? pathname.slice('/sat'.length) : pathname;
}

export function canonicalLearnHomePath(
  profile: ProductDeploymentProfile = __PINPOINT_DEPLOYMENT_PROFILE__,
): '/learn' | '/learn/library' {
  return profile === 'www-candidate' ? '/learn' : '/learn/library';
}
